import { put, takeLatest } from "redux-saga/effects";
import { SET_PAGE, SET_PAGE_FROM_HISTORY } from "../actions/page";
import {
  requestContentPage,
  requestContentPageFailed
} from "../actions/contentPage";
import { store } from "../store";

export function* watchSetPage() {
  yield takeLatest(SET_PAGE, setPage);
}

export function* watchSetPageFromHistory() {
  yield takeLatest(SET_PAGE_FROM_HISTORY, setPage);
}

function* setPage(action) {
  // Select locale
  let state = store.getState();
  let locale = state.locale.data;
  let page = action.page;

  // don't try and fetch data if request will fail regardless because of missing locale
  if (!locale) return
  if (
    state.contentMenu &&
    state.contentMenu.data &&
    state.contentMenu.data.links &&
    state.contentMenu.data.links[page]
  ) {
    yield put(
      requestContentPage(state.contentMenu.data.links[page].link, locale)
    );
  } else {
    yield put(requestContentPageFailed("Page link not found"));
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/page.js